import BasicRepository from "./basicRepository";
import Client from "../client";
import {CertificateResource} from "../resources/certificateResource";

interface CertificateRepositoryListArgs {
    archived?: boolean;
    skip?: number;
    take?: number;
    search?: string;
    tenant?: string;
    firstResult?: string;
    orderBy?: string;
}

class CertificateRepository extends BasicRepository<CertificateResource, CertificateResource, CertificateRepositoryListArgs> {
    constructor(client: Client) {
        super("Certificates", client);
    }

    names(projectId: string, projectEnvironmentsFilter: any) {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    }
    nonPrintableChars(variableSet: any) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    }
}

export default CertificateRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/certificateRepository.ts